module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "subpage addrule_edit"
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.params,
      "rules": _vm.rules,
      "show-message": true,
      "label-position": "right",
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "所属机构",
      "prop": "orgIds"
    }
  }, [_c('el-cascader', {
    ref: "cascaderOrg",
    attrs: {
      "options": _vm.orgTree,
      "show-all-levels": true,
      "props": {
        value: 'id',
        label: 'name',
        children: 'getCompanyPostModules',
        checkStrictly: true
      },
      "value": _vm.orgIds,
      "clearable": "",
      "placeholder": "请选择机构"
    },
    on: {
      "change": _vm.orgSelectChange
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "角色名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "medium",
      "placeholder": "请输入角色名称"
    },
    model: {
      value: (_vm.params.name),
      callback: function($$v) {
        _vm.$set(_vm.params, "name", $$v)
      },
      expression: "params.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "内容权限",
      "prop": "checkedSeeRule"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "true-label": 2,
      "false-label": 1
    },
    model: {
      value: (_vm.params.seeRule),
      callback: function($$v) {
        _vm.$set(_vm.params, "seeRule", $$v)
      },
      expression: "params.seeRule"
    }
  }, [_vm._v("只允许查看自己发布的文档")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "内容审核",
      "prop": "checkedCheckRule"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "true-label": 2,
      "false-label": 1
    },
    model: {
      value: (_vm.params.checkRule),
      callback: function($$v) {
        _vm.$set(_vm.params, "checkRule", $$v)
      },
      expression: "params.checkRule"
    }
  }, [_vm._v("发布内容自动通过审核")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "功能权限",
      "prop": "menuIds"
    }
  }, [_c('el-cascader', {
    ref: "cascaderMenu",
    attrs: {
      "options": _vm.menuTree,
      "collapse-tags": "",
      "props": {
        value: 'id',
        label: 'name',
        children: 'getMenuModules',
        multiple: true,
        checkStrictly: true
      },
      "value": _vm.menuIds,
      "clearable": "",
      "placeholder": "请选择菜单"
    },
    on: {
      "change": _vm.menuSelectChange
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "栏目权限",
      "prop": "columnIds"
    }
  }, [_c('el-cascader', {
    ref: "cascaderColumn",
    attrs: {
      "options": _vm.columnTree,
      "collapse-tags": "",
      "show-all-levels": true,
      "props": {
        value: 'id',
        label: 'name',
        children: 'dtos',
        multiple: true
      },
      "value": _vm.columnIds,
      "clearable": "",
      "placeholder": "请选择栏目"
    },
    on: {
      "change": _vm.columnSelectChange
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-472c49cc"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/pgment/rule/add/src/addRule.vue
// module id = 1474
// module chunks = 1